import React from 'react';

import styles from '../styles/footer.module.css';
import paths from '../paths';

const { home, terms, privacyPolicy, gallery } = paths;

const Footer = () => {
	return (
		<div className={styles.container}>
			<div className={styles.content}>
				<a href={home}>
					Home
				</a>
				<div style={{ width: '20px' }} />
				<a href={gallery}>
					Gallery
				</a>
				<div style={{ width: '20px' }} />
				<a href={privacyPolicy}>
					Privacy Policy
				</a>
				{/* <div style={{ width: '20px' }} />
				<a href={terms}>
					Terms & Conditions
				</a> */}
			</div>
		</div>
	);
}

export default Footer;